import { fork, put, takeLatest } from 'redux-saga/effects';
import { FILTER_BY_SEARCH_TERM } from '../actions/actionTypes';
import {
  filterBySearchTermDone,
  filterBySearchTermError,
  filterBySearchTermLoading,
  filterBySearchTermSuccess
} from '../actions/search';
import popSearch from '../services/pop-search';

// Create your Saga here...

export function* watchFilterBySearchTermSaga () {
  yield takeLatest(FILTER_BY_SEARCH_TERM, filterBySearchTermSaga);
}

export function* filterBySearchTermSaga ({ arraysOfStrings, searchTerm }) {
  try {
    yield put(filterBySearchTermLoading());
    let result;
    if (searchTerm) {
      result = popSearch.filterArraysOfStrings(arraysOfStrings, searchTerm);
    } else {
      result = arraysOfStrings;
    }
    yield put(filterBySearchTermSuccess(result));
  } catch (error) {
    yield put(filterBySearchTermError(error));
  } finally {
    yield put(filterBySearchTermDone());
  }
}

export default [
  fork(watchFilterBySearchTermSaga)
];
